import { createStore, createLogger } from 'vuex';
import like from './modules/like';

export default createStore({
  modules: {
    like
  },
  strict: true,
  plugins: [createLogger()]
})
